<script lang="ts">
	//Design system components
	import { Input } from '@Shelly/shelly-design-system';
	//Types
	import type { PeripheralNameSettings } from 'src/types/Peripherals';

	let className = '';
	export { className as class };

	export let settings: PeripheralNameSettings,
		label: string = '',
		icon: string = '';
</script>

<Input
	size="m"
	class={className}
	{icon}
	{label}
	bind:value={settings.name}
	id="input-tmvaphh"
	aria-labelledby="input-tmvaphh"
/>
